export interface LinkRequest {
  id: string;
  broker: string;
  date: string;
  status: LinkRequestStatus;
  accountNo: string | null;
  credential: number | null;
}

export type LinkRequestStatus = 'ACCOUNT_CREATED' | 'CONNECTION_REQUESTED' | 'REQUEST_DECLINED' | 'REQUEST_ACCEPTED' |
  'INVALID_ADDRESS' | 'INVALID_NAME' | 'INVALID_ACCOUNT' | 'INVALID_STATE'

export const ACCOUNT_CREATED: LinkRequestStatus = 'ACCOUNT_CREATED';
export const CONNECTION_REQUESTED: LinkRequestStatus = 'CONNECTION_REQUESTED';
export const REQUEST_DECLINED: LinkRequestStatus = 'REQUEST_DECLINED';
export const REQUEST_ACCEPTED: LinkRequestStatus = 'REQUEST_ACCEPTED';
export const INVALID_ADDRESS: LinkRequestStatus = 'INVALID_ADDRESS';
export const INVALID_NAME: LinkRequestStatus = 'INVALID_NAME';
export const INVALID_ACCOUNT: LinkRequestStatus = 'INVALID_ACCOUNT';
export const INVALID_STATE: LinkRequestStatus = 'INVALID_STATE';